export default __webpack_public_path__ + "static/media/bachatastyling.586f5b96.jpeg";